<shd-app-gov-header></shd-app-gov-header>
<header>
  <div class="left" >
    <div class="menu-container mobile">
      <div class="menu" (click)="cambioEstadoMenu()" (keydown.enter)="cambioEstadoMenu()" tabindex="0" aria-label="Abrir menu">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="brand pc">
      <img
        [src]="urlLogoHeader"
        alt="Logo hacienda">
    </div>
  </div>
  <div class="right">
    <div class="icon-user-text">
      <span>{{getSiglas()}}</span>
    </div>
    <div class="name-user-text">
      <div class="wellcome">
        Bienvenido(a)
      </div>
      <div class="truncado">
        {{this.nameUser}}
      </div>
    </div>
    <div class="icon-user-exit" (click)="cerrarSession()">
      <span class="material-symbols-outlined material-symbols-filled">exit_to_app</span>
    </div>
  </div>  
</header>
<div class="container-main">
  <div class="fondo-menu-active" *ngIf="estadoBoton"></div>
  <div class="container-panal-left" [class.activeMenu]="estadoBoton">
    <div class="brand mobile" *ngIf="estadoBoton">
      <div>
        <img
          [src]="urlLogoHeader"
          alt="Logo hacienda" style="width: 149px;height: 41px;">
      </div>
      <div class="x-container" (click)="cambioEstadoMenu()" (keydown.enter)="cambioEstadoMenu()" tabindex="0" aria-label="Cerrar menu">
        <div class="line line-1"></div>
        <div class="line line-2"></div>
      </div>
    </div>
    <div class="container-item item-label">
      <div>
        <span>GENERAL</span>
      </div>
    </div>
    <div class="container-item-select">
      <a href="javascript:void(0)" routerLink="/principal" [class.active]="router.url == '/principal'">
        <span class="material-symbols-outlined material-symbols-filled" >space_dashboard</span>
        <span class="text-item">Inicio</span>
      </a>
    </div>
    <div class="container-item-select">
      <a href="javascript:void(0)" (click)="getCifradoXLiquidadores()">
        <span class="material-symbols-outlined material-symbols-filled">location_home</span>
        <span class="text-item">Mi Perfil Tributario</span>
      </a>
    </div>

    <div class="container-item item-label">
      <div>
        <span >MIS IMPUESTOS</span>
      </div>
    </div>
    <div class="container-item-select pad">
      <a href="javascript:void(0)" routerLink="/industria_y_comercio" [class.active]="router.url == '/industria_y_comercio'" (mousemove)="showTooltip($event)">
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path class="icon_svg_shd-color" [class.active]="router.url == '/industria_y_comercio'" d="M19.7033 8.8003L14.8125 11.8722V9.5029C14.8125 8.84652 14.0766 8.44806 13.5158 8.8003L8.625 11.8722V5.06033C8.625 4.60039 8.24725 4.22754 7.78125 4.22754H3.84375C3.37775 4.22754 3 4.60039 3 5.06033V18.9402C3 19.4001 3.37775 19.773 3.84375 19.773H20.1562C20.6222 19.773 21 19.4001 21 18.9402V9.5029C21 8.84648 20.2641 8.44806 19.7033 8.8003Z" fill="#3366CC"/>
          </svg>
        </span>
        <span>Industria y Comercio</span>
      </a>
      <div class="tooltip-text">Agregar descuentos, obligaciones pendientes y declaraciones presentadas</div>
    </div>
    <div class="container-item-select level2 inter">
      <a href="javascript:void(0)" (click)="liquitarICA()"> 
        <span class="text-item" >Liquidar</span>
      </a>
    </div>
    <div class="container-item-select level2 inter">
      <a href="javascript:void(0)" routerLink="/por_firmar_ica" [class.active]="router.url == '/por_firmar_ica'">
        <span class="text-item">Firmar</span>
      </a>
    </div>
    <div class="container-item-select level2 final_">
      <span class="temp"></span>
      <a href="javascript:void(0)" routerLink="/por_pagar_ica" [class.active]="router.url == '/por_pagar_ica'">
        <span class="text-item">Pagar</span>
      </a>
    </div>

    <div class="container-item-select pad">
      <a href="javascript:void(0)" routerLink="/retencion_ica" [class.active]="router.url == '/retencion_ica'" (mousemove)="showTooltip($event)">
        <span>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path class="icon_svg_shd-color" [class.active]="router.url == '/retencion_ica'"  d="M17.175 14.6082H6.83625C6.7125 14.6082 6.61125 14.706 6.61125 14.8255L6.60844 16.1296C6.60844 16.2491 6.70969 16.3469 6.83344 16.3469H17.175C17.2987 16.3469 17.4 16.2491 17.4 16.1296V14.8255C17.4 14.706 17.2987 14.6082 17.175 14.6082ZM17.175 17.2163H6.82781C6.70406 17.2163 6.60281 17.3141 6.60281 17.4336L6.6 18.7376C6.6 18.8572 6.70125 18.955 6.825 18.955H17.175C17.2987 18.955 17.4 18.8572 17.4 18.7376V17.4336C17.4 17.3141 17.2987 17.2163 17.175 17.2163ZM17.175 12.0001H6.84188C6.71813 12.0001 6.61688 12.0979 6.61688 12.2174L6.61406 13.5215C6.61406 13.641 6.71531 13.7388 6.83906 13.7388H17.175C17.2987 13.7388 17.4 13.641 17.4 13.5215V12.2174C17.4 12.0979 17.2987 12.0001 17.175 12.0001ZM20.1703 8.22382L12.5175 5.14574C12.353 5.07983 12.1767 5.0459 11.9986 5.0459C11.8205 5.0459 11.6442 5.07983 11.4797 5.14574L3.82969 8.22382C3.32906 8.42758 3 8.90029 3 9.42734V18.7376C3 18.8572 3.10125 18.955 3.225 18.955H5.475C5.59875 18.955 5.7 18.8572 5.7 18.7376V12.0001C5.7 11.522 6.11063 11.1307 6.61688 11.1307H17.3831C17.8894 11.1307 18.3 11.522 18.3 12.0001V18.7376C18.3 18.8572 18.4012 18.955 18.525 18.955H20.775C20.8988 18.955 21 18.8572 21 18.7376V9.42734C21 8.90029 20.6709 8.42758 20.1703 8.22382Z" fill="#3366CC"/>
          </svg>
        </span>
        <span>Retención ICA</span>
      </a>
      <div class="tooltip-text">Declaraciones presentadas</div>
    </div>
    <div class="container-item-select level2 inter">
      <a href="javascript:void(0)" (click)="liquitarRETEICA()"> 
        <span class="text-item">Liquidar</span>
      </a>
    </div>
    <div class="container-item-select level2 inter">
      <a href="javascript:void(0)" routerLink="/por_firmar_reteica" [class.active]="router.url == '/por_firmar_reteica'">
        <span class="text-item">Firmar</span>
      </a>
    </div>
    <div class="container-item-select level2 final_">
      <span class="temp"></span>
      <a href="javascript:void(0)" routerLink="/por_pagar_reteica" [class.active]="router.url == '/por_pagar_reteica'">
        <span class="text-item">Pagar</span>
      </a>
    </div>


  </div>
  <div class="container-panal-right">
    <ng-content select="[shd-container-router-component]"></ng-content>
  </div>
</div>
<app-liquidar-ica></app-liquidar-ica>
<app-liquidar-reteica></app-liquidar-reteica>
<app-modal></app-modal>